import { useQuery } from 'react-query';

import {
  ActivityMattersResponseDto,
  ActivityOverviewResponseDto,
} from '@/../../backend/src/usage/dto/activity-overview.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export function useGetActivityOverview(organisationId: string, filters: { startDate?: string; endDate?: string } = {}) {
  const fetcher = useFetcher();
  const params = new URLSearchParams({ organisationId });
  if (filters.startDate) params.set('startDate', filters.startDate);
  if (filters.endDate) params.set('endDate', filters.endDate);
  return useQuery<ActivityOverviewResponseDto>(
    [QueryEntity.ActivityOverview, { organisationId, ...filters }],
    () => fetcher(`${APIBaseChronos}/api/usage/activity-overview?${params}`),
    { enabled: organisationId !== '', keepPreviousData: true, refetchOnWindowFocus: false },
  );
}

export function useGetActivityMatters(organisationId: string, page: number, pageSize = 15) {
  const fetcher = useFetcher();
  return useQuery<ActivityMattersResponseDto>(
    [QueryEntity.ActivityOverview, 'matters', { organisationId, page, pageSize }],
    () =>
      fetcher(
        `${APIBaseChronos}/api/usage/activity-matters?organisationId=${encodeURIComponent(organisationId)}&page=${page}&pageSize=${pageSize}`,
      ),
    { enabled: organisationId !== '', keepPreviousData: true, refetchOnWindowFocus: false },
  );
}
